<template>
  <div>
    <section class="uc-knowledgeFilter uc-ml10" v-if="tagList.length > 0">
      <div class="item" v-for="(item, index) in tagList" :key="index">
        <span class="txt">{{ item.name }}</span>
        <div class="con">
          <a
            href="javascript:;"
            :class="tagSel == 0 ? 'on' : ''"
            @click="
              tagSel = 0;
              handleTagClick(undefined);
            "
            >全部</a
          >
          <a
            href="javascript:;"
            v-for="(item, index) in item.tag_list"
            :key="index"
            :class="tagSel == item.id ? 'on' : ''"
            @click="
              tagSel = item.id;
              handleTagClick(item.id);
            "
            >{{ item.label }}</a
          >
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg uc-pb40">
      <div class="container">
        <div class="row">
          <div class="col-24 col-sm-24">
            <section class="g-filterSearch uc-ml10 uc-pr10">
              <div
                v-for="(item, index) in tabList"
                :key="index"
                class="item"
                :class="item.status == query.status ? 'on' : ''"
                @click="
                  query.status = item.status;
                  loadData();
                "
              >
                {{ item.name }}
              </div>
              <div class="search">
                <input
                  type="text"
                  placeholder="请输入您想查询的话题"
                  class="uc-input"
                  v-model="query.keyword"
                  @keyup.enter="loadData"
                />
                <input
                  type="submit"
                  value="搜索"
                  class="uc-btn blue"
                  @click="loadData"
                />
              </div>
            </section>
            <section class="container uc-encyclopediasList uc-topicList">
              <div class="content-empty" v-if="list.total_count == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div class="row">
                <div
                  v-for="(item, index) in list.items"
                  :key="index"
                  class="col-8 box"
                >
                  <router-link
                    :to="{
                      name: 'TopicDetails',
                      params: { id: item.id },
                    }"
                    class="item"
                    :style="
                      `background:url(${item.cover}); background-size:cover;`
                    "
                  >
                    <h3>{{ item.title }}</h3>
                    <div class="txt"></div>
                    <div class="btm">
                      <div class="left">
                        <div class="avatar-list">
                          <img
                            v-for="(item2, index2) in item.top5_answer_user"
                            :key="index2"
                            :src="item2.avatar"
                            :alt="item2.first_name"
                            :style="index2 == 0 ? 'margin-left:0;' : ''"
                            onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                          />
                        </div>
                        {{ item.topic_answer_count }}人参与讨论
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </section>

            <el-pagination
              class="uc-prvNxt"
              background
              layout="prev, pager, next"
              hide-on-single-page
              :current-page="query.pageIndex"
              :page-size="query.pageSize"
              :total="list.total_count"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'StudyTopic',
  data() {
    return {
      tagSel: 0,
      tabList: [
        { name: '最新', status: 0 },
        { name: '最热', status: 1 },
      ],
      query: {
        tagId: undefined,
        status: 0,
        pageIndex: 1,
        pageSize: 9,
        keyword: undefined,
      },
      list: {},
      tagList: {},
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.loadData();
      this.getTags();
    },
    loadData() {
      this.getMyTopics();
    },
    async getTags() {
      const response = await this.$api.tag.getTags();
      this.tagList = response.data.data;
    },
    async getMyTopics() {
      const response = await this.$api.topic.getMyTopics(this.query);
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
    // 切换标签
    handleTagClick(tagId) {
      this.query.tagId = tagId;
      this.loadData();
    },
  },
};
</script>
